import { useCallback, useEffect, useState } from 'react';
import { useFormState } from 'react-final-form';
import { useLazyQuery } from '@apollo/client';
import { FORM_VALUES } from '../utils/helpers/constants';
import { landmarksQuery } from '../queries/landmarks';

export const useLandmarks = coordinates => {
  const { values } = useFormState();
  const [locations, setLocations] = useState(undefined);

  const landmarksQueryVariables = {
    cityId: values[FORM_VALUES.cityId],
    latitude: coordinates?.lat,
    longitude: coordinates?.lng
  };
  const [getLandmarks] = useLazyQuery(landmarksQuery(landmarksQueryVariables), {
    onCompleted: data => setLocations(data.landmarks),
    variables: landmarksQueryVariables
  });

  const handleLocationDelete = useCallback(
    id => {
      const updatedLocations = locations?.filter(
        location => location.id !== id
      );
      setLocations(updatedLocations);
    },
    [locations]
  );

  useEffect(() => {
    getLandmarks();
  }, []);

  return {
    locations,
    getLandmarks,
    handleLocationDelete
  };
};
